import {ReflexiveRestModel} from '../../../lib/reflexive-model/reflexive-rest-model';
import {FieldType} from '../../../lib/reflexive-model/field-type.enum';
import {AbstractControl, FormGroup, Validators} from '@angular/forms';

export class PaymentServiceModel extends ReflexiveRestModel {
  public static readonly PAYMENT_TYPE_OPLATI = 'oplati';
  public static readonly PAYMENT_TYPE_IDRAM = 'idram';
  public static readonly PAYMENT_TYPE_PAYANYWAY_SBP = 'payanyway-sbp';
  public static readonly PAYMENT_TYPE_CLOUDPAYMENTS_SBP = 'cloudpayments-sbp';

  constructor() {
    super();
    this.fields = {
      id: {
        type: FieldType.IntegerField,
        label: 'id',
        value: null,
        isVisible: () => false
      },
      name: {
        type: FieldType.StringField,
        label: 'Name',
        value: null,
        validators: [Validators.required]
      },
      type: {
        type: FieldType.ImmutableListField,
        label: 'Type',
        value: null,
        onChange: (event, formGroup) => {
          const fG = <FormGroup> formGroup.root;
          [
            'reg_num',
            'password',
            'secret_key',
            'merchant_id'
          ].forEach(
            field => {
              if (fG.controls[field]) {
                fG.controls[field].setValue(null);
              }
            }
          );
        },
        immutableList: {
          name: 'payment-service-type',
        },
      },

      project_country_id: {
        type: FieldType.ForeignSourceField,
        label: 'Country',
        placeholder: 'Select a country',
        value: undefined,
        foreignSource: {
          modelName: 'project-country',
          keyField: 'id',
          displayedField: 'country_name',
          fields: 'id,country_code,project_custom_name',
          expand: 'country_name',
          groupBy: 'project_custom_name',
          searchModelName: 'ProjectCountrySearch',
          // filterBehaviorSubject: new BehaviorSubject<RestFilterModel>(null),
        },
        validators: [Validators.required],
      },
      description: {
        type: FieldType.StringField,
        label: 'Description',
        value: null,
        validators: [],
        multiline: true
      },
      merchant_id: {
        type: FieldType.StringField,
        label: 'Merchant Id',
        value: null,
        isVisible: formGroup => this.paymentTypeIsIdram(formGroup),
      },
      secret_key: {
        type: FieldType.StringField,
        label: 'Secret Key',
        value: null,
        isVisible: formGroup => this.paymentTypeIsIdram(formGroup),
      },
      reg_num: {
        type: FieldType.StringField,
        label: 'Cash register registration number',
        placeholder: 'Enter registration number',
        value: null,
        validators: [
          (abstractControl: AbstractControl) => {
            const formGroup = <FormGroup> abstractControl.root;
            if (this.paymentTypeIsOplati(formGroup)) {
              return Validators.required(abstractControl);
            }
            return null;
          }
        ],
        isVisible: formGroup => this.paymentTypeIsOplati(formGroup),
      },
      password: {
        type: FieldType.PasswordField,
        label: 'Password',
        placeholder: 'Enter password',
        value: null,
        validators: [
          (abstractControl: AbstractControl) => {
            const formGroup = <FormGroup> abstractControl.root;
            if (this.paymentTypeIsOplati(formGroup)) {
              return Validators.required(abstractControl);
            }
            return null;
          }
        ],
        isVisible: formGroup => this.paymentTypeIsOplati(formGroup),
      },
      acquirer_id: {
        type: FieldType.ForeignSourceField,
        label: 'Acquirer',
        value: null,
        validators: [],
        foreignSource: {
          modelName: 'read-only-acquirer',
          keyField: 'id',
          displayedField: 'name',
          fields: 'id,name',
          searchModelName: 'ReadOnlyAcquirerSearch',
        },

        isVisible: formGroup => this.paymentTypeIsPayanywaySbp(formGroup) || this.paymentTypeIsCloudpaymentsSbp(formGroup),
      },
    };
  }

  paymentTypeIsOplati(formGroup: FormGroup): boolean {
    return formGroup && formGroup.controls
      && formGroup.controls.type
      && formGroup.controls.type.value === PaymentServiceModel.PAYMENT_TYPE_OPLATI;
  }
  paymentTypeIsIdram(formGroup: FormGroup): boolean {
    return formGroup && formGroup.controls
      && formGroup.controls.type
      && formGroup.controls.type.value === PaymentServiceModel.PAYMENT_TYPE_IDRAM;
  }
  paymentTypeIsPayanywaySbp(formGroup: FormGroup): boolean {
    return formGroup && formGroup.controls
      && formGroup.controls.type
      && formGroup.controls.type.value === PaymentServiceModel.PAYMENT_TYPE_PAYANYWAY_SBP;
  }
  paymentTypeIsCloudpaymentsSbp(formGroup: FormGroup): boolean {
    return formGroup && formGroup.controls
      && formGroup.controls.type
      && formGroup.controls.type.value === PaymentServiceModel.PAYMENT_TYPE_CLOUDPAYMENTS_SBP;
  }
}
